import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalController, LoadingController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { IssuesFilterSupplier, Job, Localization, House, StatesGroups, Phases, CsiteSupplier, QuproList } from '@arpada/arp-lib-common-qupro';
import { Subscription } from 'rxjs';

import { MessagesService, PortalProveedorService } from '../../../../services/api.services';
import { OperatorFront, IssuesFilterComponentsValues } from '../../../../models/api.models';

import { ActionsSharedData } from '../actions.shared.data';
import { IssuePopulateService } from '../../../../services/populators/issue-populate.service';

@Component({
  selector: 'app-filter-issues',
  templateUrl: './filter-issues.component.html',
  styleUrls: ['./filter-issues.component.scss'],
})
export class FilterIssuesComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() filter: IssuesFilterSupplier;
  @Input() sharedData: ActionsSharedData;
  @Input() operarios: OperatorFront[];
  @Input() filterChange = new EventEmitter();
  @Input() postsaleFilter: boolean;
  @Input() presaleFilter: boolean;
  @Input() isModal: boolean;
  @Input() showOperatorFilter: boolean;

  @ViewChild('filterForm', { static : true }) filterForm: NgForm;
  @ViewChild('jobsSelectable', { static: true }) jobsSelectable: IonicSelectableComponent;
  @ViewChild('locationsSelectable', { static: true }) locationsSelectable: IonicSelectableComponent;
  @ViewChild('csitesSelectable', { static: true }) csitesSelectable: IonicSelectableComponent;

  detectChanges = false;
  csiteSelected = false;
  enviromentSelected = false;
  portalSelected = false;
  floorSelected = false;
  disableOperatorFilter = true;
  houses: House[] = [];
  portals: string[] = [];
  floors: string[] = [];
  letters: string[] = [];
  locations: Localization[] = [];
  jobsArray: Job[] = [];
  componentsValues: IssuesFilterComponentsValues = null;

  private detectChangesSubscription: Subscription = null;
  private loginRedirectSubscription: Subscription;
  private modalId: string = null;

  constructor(
    private modalController: ModalController,
    private messages: MessagesService, 
    private portalProveedorService: PortalProveedorService,
    private issuePopulateService: IssuePopulateService
    ) { }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      this.modalController.getTop().then((top: HTMLIonModalElement) => {
        this.modalId = top.id; // Get modal ID for close it
      });
      const operatorGlobalSelected = this.portalProveedorService.getOperatorSel();
      if (!operatorGlobalSelected || operatorGlobalSelected === undefined || operatorGlobalSelected === -2) {
        this.disableOperatorFilter = false;
      }
      this.componentsValues = {
        commonArea: this.filter ? this.filter.common_area : null,
        presaleIsChecked: this.filter && this.filter.containsPhaseKey(Phases.PRESALE),
        reviewIsChecked: this.filter && this.filter.containsPhaseKey(Phases.REVIEW),
        postsaleIsChecked: this.filter && this.filter.containsPhaseKey(Phases.POSTSALE), // en verdad no hace falta
        pendingProcessingIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.PENDING_PROCESSING),
        processedNoDateIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.PROCESSED_NO_DATE),
        processedDateIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.PROCESSED_DATE),
        pendingMaterialIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.PENDING_MATERIAL),
        repairedClosedIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.REPAIRED_CLOSE),
        notApplicableIsChecked: this.filter && this.filter.containsStateGroupKey(StatesGroups.NOT_APPLICABLE),
        createDateFrom: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.create_date_from) : null,
        createDateTo: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.create_date_to) : null,
        appointmentDateFrom: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.appointment_date_from) : null,
        appointmentDateTo: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.appointment_date_to) : null,
        localizationSelectId: this.filter ? this.filter.location_id : null,
        portal: this.filter ? this.filter.portal : null,
        floor: this.filter ? this.filter.floor : null,
        door: this.filter ? this.filter.letter : null,
        jobsSelectIds: this.filter ? this.filter.getJobsIds() : null,
        csiteId: this.filter ? this.filter.csite_id : null,
        operatorId: this.initOperatorNum(this.filter.operator_num),
        state: this.filter ? this.filter.state : null,
        idSelected: this.filter ? this.filter.id : null,
        supplierPartnerAssignmentDateFrom: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.supplier_partner_assignment_date_from) : null,
        supplierPartnerAssignmentDateTo: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.supplier_partner_assignment_date_to) : null
      };
      this.selectCsite();  // para caso de cerrar y volver a abrir filtro
      if (this.postsaleFilter) {
        this.portalProveedorService.getCachedJobs().subscribe((jobsList: QuproList<Job>) => {
          this.jobsArray = jobsList.elements;
          this.asignJobsSelectsOrderedToSelectable();
        });
      }
    });
  }

  private initOperatorNum(num: number): number {
    let operatorNum: number;
    if (num) {
      operatorNum = num;
    } else {
      operatorNum = -2; // caso de TODOS
    }
    return operatorNum;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.detectChanges = true;
      this.detectChangesSubscription = this.filterForm.valueChanges.subscribe(this.onChangeComponent);
    });
  }

  onChangeComponent = () => {
    if (this.detectChanges) {
      setTimeout(() => {
        this.updateFiltro();
      }, 50); // Time to apply filters, after change this.filter
    }
  }

  ngOnDestroy() {
    if (this.detectChangesSubscription) {
      this.detectChangesSubscription.unsubscribe();
    }
    this.detectChanges = false;
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  removeDuplicados(list: string[]): string[] {
    return list.filter((item, index) => {
      return list.indexOf(item) === index;
    });
  }
  selectCsite() {
    if (this.componentsValues.csiteId) {
      this.csiteSelected = true;
      this.portalProveedorService.getCachedLocations(this.componentsValues.csiteId, null).subscribe(resp => {
        this.locations = resp.elements;
      });
    } else {
      this.csiteSelected = false;
      this.componentsValues.commonArea = null;
      this.componentsValues.localizationSelectId = null;
      this.selectEnvironment();
    }
  }

  selectEnvironment() {
    this.portals = [];
    this.locations = [];
    this.portalProveedorService.getCachedLocations(this.componentsValues.csiteId, this.componentsValues.commonArea).subscribe(resp => {
      this.locations = resp.elements;
    });
    if (this.componentsValues.commonArea || this.componentsValues.commonArea === 0) {
      this.enviromentSelected = true;
      let commonArea = false;
      if (this.componentsValues.commonArea === 1) {
        commonArea = true;
      }
      this.portalProveedorService.getCachedHouses(this.componentsValues.csiteId, commonArea).subscribe(resp => {
        this.houses = resp.elements;
        this.houses.forEach(house => {
          this.portals.push(house.portal);
        });
        this.portals = this.removeDuplicados(this.portals);
      });
    } else {
      this.enviromentSelected = false;
      this.componentsValues.portal = null;
      this.selectPortal();
    }
  }

  selectPortal() {
    this.floors = [];
    this.portalSelected = false;
    this.componentsValues.floor = null;
    if (this.componentsValues.portal) {
      this.houses.forEach(house => {
        if (this.componentsValues.portal === house.portal) {
          this.floors.push(house.floor);
        }
      });
      this.floors = this.removeDuplicados(this.floors);
      this.portalSelected = true;
    } else {
      this.portalSelected = false;
      this.componentsValues.floor = null;
      this.selectFloor();
    }
  }

  selectFloor() {
    this.letters = [];
    this.floorSelected = false;
    this.componentsValues.door = null;
    if (this.componentsValues.floor) {
      this.houses.forEach(house => {
        if ((this.componentsValues.portal === house.portal) && (this.componentsValues.floor === house.floor)) {
          this.letters.push(house.letter);
        }
      });
      this.letters = this.removeDuplicados(this.letters);
      this.floorSelected = true;
    } else {
      this.floorSelected = false;
      this.componentsValues.door = null;
    }
  }

  clearDateFilter(dateFilterPropertyKey: string) {
    if (this.componentsValues && this.componentsValues[dateFilterPropertyKey]) {
      this.componentsValues[dateFilterPropertyKey] = null;
      this.updateDates();
    }
  }

  isTotalCountDefined() {
    return this.sharedData && this.sharedData.totalCount
           && this.sharedData.totalCount !== '' && parseInt(this.sharedData.totalCount, 10) >= 0;
  }

  onSelectJobId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: Job}) {
    if (!this.componentsValues.jobsSelectIds) {
      // console.log('onSelectJobId - this.componentsValues.jobsSelectIds: ', this.componentsValues.jobsSelectIds);
      this.componentsValues.jobsSelectIds = [];
    }
    const index: number = this.componentsValues.jobsSelectIds.indexOf(eventSelectable.item.id);
    if (eventSelectable.isSelected) {
      if (index < 0) {
        // console.log('index: ', index);
        this.componentsValues.jobsSelectIds.push(eventSelectable.item.id);
      }
    } else {
      if (index >= 0) {
        // console.log('index: ', index);
        const result = this.componentsValues.jobsSelectIds.splice(index, 1);
        // console.log('result: ', result);
      }
    }
    setTimeout(() => {
      this.updateFiltro();
    }, 50); // Time to apply filters, after change this.filter
  }

  onSelectLocationId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: Localization}) {
    if (!this.componentsValues.localizationSelectId) {
      this.componentsValues.localizationSelectId = null;
    }
    const index: number = this.componentsValues.localizationSelectId = eventSelectable.item.id;
    if (eventSelectable.isSelected) {
      if (index > 0) {
        this.componentsValues.localizationSelectId = eventSelectable.item.id;
      }
    } else {
      // creo que no hace falta
    }
    setTimeout(() => {
      this.updateFiltro();
    }, 50); // Time to apply filters, after change this.filter
  }

  onSelectCsitesId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: CsiteSupplier}) {
    if (!this.componentsValues.csiteId) {
      this.componentsValues.csiteId = null;
    }
    const index: number = this.componentsValues.csiteId = eventSelectable.item.id;
    if (eventSelectable.isSelected) {
      if (index > 0) {
        this.componentsValues.csiteId = eventSelectable.item.id;
        this.csiteSelected = true;
      }
    } else {
      // creo que no hace falta
      // console.log('this.componentsValues.csiteId: ', this.componentsValues.csiteId);
      this.csiteSelected = false;
    }
    setTimeout(() => {
      this.updateFiltro();
    }, 50); // Time to apply filters, after change this.filter
  }

  onChangeJobsSelects() {
    this.asignJobsSelectsOrderedToSelectable();
  }

  clearJobsSelectedItems() {
    this.componentsValues.jobsSelectIds = [];
    this.filter.setJobsIds(null);
    this.locationsSelectable.value = null;
    this.updateFiltro();
  }

  clearCsitesSelectedItems() {
    this.componentsValues.csiteId = null;
    this.csiteSelected = false;
    this.updateFiltro();
  }
  clearLocationSelectedItems() {
    this.componentsValues.localizationSelectId = null;
    this.updateFiltro();
  }

  asignJobsSelectsOrderedToSelectable() {
    if (this.componentsValues.jobsSelectIds) {
      const jobsToSelect: Job[] = [];
      for (const jobId of this.componentsValues.jobsSelectIds) {
        const job: Job = this.getJobByJobId(jobId);
        if (job) {
          jobsToSelect.push(job);
        }
      }
      if (jobsToSelect) {
        jobsToSelect.sort((job1, job2) => job1.name.localeCompare(job2.name));
        this.jobsSelectable.value = jobsToSelect;
      }
    }
  }

  getJobByJobId(jobId: number): Job {
    if (jobId >= 0) {
      for (const job of this.jobsArray) {
        if (job && job.id === jobId) {
          return job;
        }
      }
    }
    return null;
  }

  updateFiltro() {
    if ( !this.componentsValues ) { return; }
    this.updateCsites();
    this.updateHouseOrCommonArea();
    this.updatePhases();
    this.updateStatesGroups();
    this.updateFeatures();
    this.updateDates();
    this.updateOperario();
    this.updateState();
    this.updateId();
    if (this.componentsValues.state) {
    }
    this.filterChange.emit(this.filter);
    this.portalProveedorService.issuesReviewResetRowsSelectedEvent.emit('resetea las columnas seleccionadas!!');
  }

  private updateId() {
    this.filter.id = this.componentsValues.idSelected;
  }

  private updateHouseOrCommonArea() {
    this.reloadIfIsNeededHouseOrCommonAreaSelectBox();
    this.filter.common_area = this.componentsValues.commonArea;
    this.filter.portal = this.componentsValues.portal;
    this.filter.floor = this.componentsValues.floor;
    this.filter.letter = this.componentsValues.door;
  }

  private updateCsites() {
    this.filter.csite_id = this.componentsValues.csiteId;
  }

  private updateOperario() {
    if (this.componentsValues.operatorId === -2) {
      this.filter.operator_num = null;
    } else {
      this.filter.operator_num = this.componentsValues.operatorId;
    }
  }

  private updateFeatures() {
    this.filter.location_id = this.componentsValues.localizationSelectId;
    this.filter.setJobsIds(this.componentsValues.jobsSelectIds && this.componentsValues.jobsSelectIds.length > 0
      ? this.componentsValues.jobsSelectIds : null);
  }

  private updatePhases() {
    const phaseArray: string[] = [];
    if (this.componentsValues.postsaleIsChecked) {
      phaseArray.push(Phases.POSTSALE);
    }
    if (this.componentsValues.presaleIsChecked) {
      phaseArray.push(Phases.PRESALE);
    }
    if (this.componentsValues.reviewIsChecked) {
      phaseArray.push(Phases.REVIEW);
    }
    if (this.presaleFilter) {
      this.filter.setPhaseKeys(phaseArray);
    }
  }

  private updateStatesGroups() {
    this.filter.state = null;
    const stateGroups: string[] = [];
    if (this.componentsValues.pendingProcessingIsChecked) {
      stateGroups.push(StatesGroups.PENDING_PROCESSING);
    }
    if (this.componentsValues.processedNoDateIsChecked) {
      stateGroups.push(StatesGroups.PROCESSED_NO_DATE);
    }
    if (this.componentsValues.processedDateIsChecked) {
      stateGroups.push(StatesGroups.PROCESSED_DATE);
    }
    if (this.componentsValues.pendingMaterialIsChecked) {
      stateGroups.push(StatesGroups.PENDING_MATERIAL);
    }
    if (this.componentsValues.repairedClosedIsChecked) {
      stateGroups.push(StatesGroups.REPAIRED_CLOSE);
    }
    if (this.componentsValues.notApplicableIsChecked) {
      stateGroups.push(StatesGroups.NOT_APPLICABLE);
    }
    this.filter.setStateGroupKeys(stateGroups);
  }

  private updateState() {
    if (this.componentsValues.state) {
      this.filter.state = 'issue_repaired';
      const stateGroups = null;
      this.filter.setStateGroupKeys(stateGroups);
    } else {
      this.filter.state = null;
    }
  }

  private reloadIfIsNeededHouseOrCommonAreaSelectBox() {
    if (this.filter.common_area !== this.componentsValues.commonArea) {
      this.reloadPortalSelect();
    } else if (this.filter.portal !== this.componentsValues.portal) {
      this.reloadFloorSelect();
    } else if (this.filter.floor !== this.componentsValues.floor) {
      this.reloadDoorSelect();
    }
  }

  private reloadDoorSelect() {
    if (this.componentsValues.floor) {
      this.loadDoorSelect();
    } else {
      this.letters = null;
    }
    this.componentsValues.door = null;
  }

  private reloadPortalSelect() {
    if (this.componentsValues.commonArea === 0) {
      this.loadPortalSelect();
    } else {
      this.portals = null;
    }
    this.componentsValues.portal = null;
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.floors = null;
    this.letters = null;
  }

  private loadPortalSelect() {
    this.portals = [];
    for (const house of this.houses) {
      if (house.common_area === this.componentsValues.commonArea &&
          this.portals.indexOf(house.portal) < 0) {
        this.portals.push(house.portal);
      }
    }
    this.portals.sort();
  }

  private reloadFloorSelect() {
    if (this.componentsValues.portal) {
      this.loadFloorSelect();
    } else {
      this.floors = null;
    }
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.letters = null;
  }

  private loadDoorSelect() {
    this.letters = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          house.floor === this.componentsValues.floor &&
          this.letters.indexOf(house.letter) < 0) {
        this.letters.push(house.letter);
      }
    }
    this.letters.sort();
  }

  private loadFloorSelect() {
    this.floors = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          this.floors.indexOf(house.floor) < 0) {
        this.floors.push(house.floor);
      }
    }
    this.floors.sort();
  }

  private updateDates() {
    if (this.componentsValues.createDateFrom) {
      const createDateFrom: Date = new Date(this.componentsValues.createDateFrom);
      createDateFrom.setHours(0, 0, 0, 0);
      this.filter.create_date_from = createDateFrom.getTime();
    } else {
      this.filter.create_date_from = null;
    }
    if (this.componentsValues.createDateTo) {
      const createDateTo: Date = new Date(this.componentsValues.createDateTo);
      createDateTo.setHours(23, 59, 59, 999);
      this.filter.create_date_to = createDateTo.getTime();
    } else {
      this.filter.create_date_to = null;
    }
    if (this.componentsValues.appointmentDateFrom) {
      const appointmentDateFrom: Date = new Date(this.componentsValues.appointmentDateFrom);
      appointmentDateFrom.setHours(0, 0, 0, 0);
      this.filter.appointment_date_from = appointmentDateFrom.getTime();
    } else {
      this.filter.appointment_date_from = null;
    }
    if (this.componentsValues.appointmentDateTo) {
      const appointmentDateTo: Date = new Date(this.componentsValues.appointmentDateTo);
      appointmentDateTo.setHours(23, 59, 59, 999);
      this.filter.appointment_date_to = appointmentDateTo.getTime();
    } else {
      this.filter.appointment_date_to = null;
    }
    if (this.componentsValues.supplierPartnerAssignmentDateFrom) {
      const supplierPartnerAssignmentDateFrom: Date = new Date(this.componentsValues.supplierPartnerAssignmentDateFrom);
      supplierPartnerAssignmentDateFrom.setHours(0, 0, 0, 0);
      this.filter.supplier_partner_assignment_date_from = supplierPartnerAssignmentDateFrom.getTime();
    } else {
      this.filter.supplier_partner_assignment_date_from = null;
    }
    if (this.componentsValues.supplierPartnerAssignmentDateTo) {
      const supplierPartnerAssignmentDateTo: Date = new Date(this.componentsValues.supplierPartnerAssignmentDateTo);
      supplierPartnerAssignmentDateTo.setHours(23, 59, 59, 999);
      this.filter.supplier_partner_assignment_date_to = supplierPartnerAssignmentDateTo.getTime();
    } else {
      this.filter.supplier_partner_assignment_date_to = null;
    }
  }

  // private getStringOfTimestamp(timestamp: number): string {
  //   let toReturn: string = null;
  //   if (timestamp) {
  //     toReturn = new Date(timestamp).toISOString();
  //     // formatDate( timestamp, 'YYYY-MM-DDThh:mm:ss.sTZD', 'es', '+0100');
  //   }
  //   return toReturn;
  // }

  public dismiss() {
    this.detectChanges = false;
    this.modalController.dismiss({
      dismissed: true
    }, null, this.modalId);
  }

}
